import React from 'react';
import { isEmpty } from 'lodash';
import { F } from 'ramda';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Money from '../../../common/money';
import defaultAvatar from '../../../../../images/avatar.svg';

const Barber = ({ barber, faded, onClick }) => {
  if (isEmpty(barber)) return <div />;

  return (
    <button
      className={classnames('c-tipping-view-barber', { 'is-faded': faded })}
      type="button"
      onClick={onClick}
    >
      <div className="c-tipping-view-barber__img">
        <img src={barber.photo || defaultAvatar} alt="" />
      </div>
      <div className="c-tipping-view-barber__name">{barber.firstName}</div>
      <div className="c-tipping-view-barber__price">
        <Money>{barber.priceForTip}</Money>
      </div>
      <div className="c-tipping-view-barber__tipping-price">
        <span display-if={barber.tipAmount}>Tip{' '}</span>
        <em><Money display-if={barber.tipAmount}>{barber.tipAmount}</Money></em>
      </div>
    </button>
  );
};
Barber.propTypes = {
  barber: PropTypes.shape({
    id: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    priceForTip: PropTypes.number.isRequired,
    photo: PropTypes.string,
    tipAmount: PropTypes.number,
  }),
  faded: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
Barber.defaultProps = {
  barber: null,
  faded: false,
  onClick: F,
};

export default Barber;
